<template>
    <div>
        <tsoft-table
            name="agent-company"
            :key="componentRefreshKey"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :additionalGetParameter="additionalGetParameter"
            :isNeedCreate="isNeedCreate"
            :typeOfTableFilter="typeOfTableFilter"
            :onDataEmptyMessage="'Агенты по заданному фильтру отсутствуют. Попробуйте снова.'"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
            @onMap="onMap"
        />

        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
            no-wrap
        ></b-overlay>

        <b-sidebar
            v-if="isSidebarOpen"
            v-model="isSidebarOpen"
            id="sidebar-right-create-or-edit-agent-company"
            right
            backdrop
            shadow
            width="65em"
            backdrop-variant="dark"
            ref="editItem"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__" v-html="modalTitle()"></strong>
                </div>
            </template>
            <div class="d-block">
                <AgentCompanyProfile 
                    :agent_company="editedItem" 
                    @closed="isSidebarOpen=false"
                    @updated="profileUpdated"
                />
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    import {API_AGENT_COMPANY} from "@/constants";
    import AgentCompanyProfile from "@/components/agentCompanies/AgentCompanyProfile";

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem
    } from '@/mixins';

    const initialEditedItem = () => ({
        id: null,
        full_name: '',
        type: '',
        inn: '',
        ogrnip: '',
        registration_address: '',
        address: '',
        region: '',
        bank_account: '',
        bank_name: '',
        bik: '',
        correspondent_account: '',
        passport_series: '',
        passport_number: '',
        passport_issued_by: '',
        passport_issued_code: '',
        passport_issued_date: '',
        birth_date: '',
        snils: '',
        ogrnip_file_id: null,
        inn_file_id: null,
        passport_main_file_id: null,
        passport_registration_file_id: null,
        bank_file_id: null,
        snils_file_id: null,
        user: {},
        latestStatusWithComments: {},
        ogrnipFile: {},
        innFile: {},
        passportMainFile: {},
        passportRegistrationFile: {},
        bankFile: {},
        snilsFile: {}
    })

    export default {
        components: {
            AgentCompanyProfile
        },    
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionDeleteItem,
            actionCreateOrUpdateItem
        ],
        props: {
            isNeedCreate: { type: Boolean, required: false, default: true },        // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &finance_id=10
            typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: orders, services
        },
        data() {
            return {
                loading: false,
                tableApiUrl: API_AGENT_COMPANY,
                componentRefreshKey: 0,
                dataOverlay: false
            }
        },
        watch: {
        },
        mounted() {
            this.editedItem = initialEditedItem();
            this.initialAssign();
        },
        methods: {
            initialAssign() {
                // this.editedItem.company_id = this.company_id;
            },
            // calls from mixin before sidebaropened
            beforeSidebarOpenedCallback() {
                this.editedItem = initialEditedItem();
                this.initialAssign();
            },
            // calls from mixin on item save
            onCreatedOrUpdatedCallback() {
                this.isSidebarOpen = false
            },
            profileUpdated(data) {
                this.$nextTick(() => {
                    api.call("get", `${API_AGENT_COMPANY}/${this.items.data[this.editIndex].id}`).then(({data}) => {
                        Object.assign(this.items.data[index], data);
                        this.onCreatedOrUpdatedCallback();

                        this.editIndex = -1;
                        this.validationErrors = '';
                        this.makeToast('success');

                    }).catch((response) => {
                    })
                })
            },
            onDeletedCallback() {
                this.componentRefreshKey++
                this.updateParentData()
            },
            modalTitle() {
                let title = 'Добавление агентсткой компании'
                if (this.editIndex > -1) {
                    title = 'Редактирование агентской компании #' + this.editedItem.id
                }

                return title
            },
            updateParentData() {
                this.$emit("updateParentData")
            },
            onMap() {
                this.$emit("onMap")
            }
        }
    }
</script>
